import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { PublicHttpClientService } from "./http-client.service";

@Injectable()
export class PublicAccountsService {
  constructor(private publicHttp: PublicHttpClientService) {}

  public setEmailResponse(
    account_id: number | string,
    data: { vin: string; response: string | number }
  ): Observable<unknown> {
    return this.publicHttp
      .post(`/api/accounts/${account_id}/email_response`, { ...data })
      .pipe(tap((_) => console.log("PublicAccountsService.setEmailResponse: Ok.")));
  }

  public notifyCsReceiptReceived(account_id: any): Observable<any> {
    return this.publicHttp
      .post(`/api/accounts/${account_id}/early_settlement/notify_receipt_received`, {})
      .pipe(tap((_) => console.log("PublicAccountsService.notifyCsReceiptReceived: Ok.")));
  }
}
